export default __webpack_public_path__ + "images/commercial-icon@3x.png?d494a211afd63cfe2ee0cfa2ada8de1f";